module.exports = __webpack_public_path__ + "img/israel.f85b297f.png";